<template>
  <div class="page has-search" :class="filtersActive && filterNoticeDescription.length ? 'has-filter-notice' : ''">
    <div class="page-header">
      <button class="header-nav-btn" @click="$parent.$refs.nav.open()" aria-label="Open nav menu"></button>

      <span class="page-title"><span class="icon">Events</span></span>
      <HeaderNav />

      <button class="header-filter" @click="openFilters">Filter</button>
    </div>

    <div class="filter-notice" v-show="filtersActive && filterNoticeDescription.length">
      <p>Filtered by: <span>{{ filterNoticeDescription }}</span></p>
      <button class="clear" @click="clearFilters"></button>
    </div>

    <div class="page-search">
      <input type="text" v-model="search" v-on:keyup.enter="hideKeyboard" v-on:blur="hideKeyboard" v-on:focus="showKeyboard">
      <p class="input-placeholder" v-if="search.length === 0">Search</p>
      <button v-if="search.length" class="clear gray" @click="search = ''"></button>
    </div>

    <div v-if="pageData.acf" class="page-content">
      <Components :components="pageData.acf.components" location="above" />

      <div v-for="day in days" :key="day[0].date">
        <h2 v-if="$root.app" class="day">{{day[0].date}}</h2>

        <ul class="list" v-if="$root.app">
          <CellEvent v-for="event in day" :event="event" :key="event.id"></CellEvent>
        </ul>

        <div v-else class="page-container">
          <h2 class="day">{{day[0].date}}</h2>
          <div class="events-grid list-container">
            <div v-for="event in day" :key="event.id" class="event">
              <div class="event-content">
                <span class="event-stats">{{event.category}} &bull; {{event.event_type === 'Other' ? event.event_type_other : event.event_type}}</span>

                <img v-if="event.featured_images" :src="event.featured_images[0].image.url" :alt="event.featured_images[0].image.alt">

                <span class="event-name">{{event.program_title}}</span>
                <span class="artist-name">{{event.artist_name}}</span>

                <span class="event-date">{{event.date}} {{event.time}}</span>

                <a :href="`http://maps.google.com/?q=` + encodeURIComponent(`${event.address} ${event.city} ${event.state} ${event.zip}`)" class="tour-address" target="_blank">{{event.address}} {{event.address_2}} {{event.city}} {{event.zip}}</a>

                <p>{{event.description}}</p>

                <a v-if="event.additional_links && event.additional_links.indexOf('http') > -1" :href="event.additional_links" class="btn" target="_blank">Additional Resources</a>
                <a v-if="event.location_rsvp && event.location_rsvp.indexOf('http') > -1" :href="event.location_rsvp" class="btn" target="_blank">RSVP</a>

                <span class="location-details"><template v-if="event.location_type">{{event.location_type}}</template><template v-if="event.location_experience.length"><span v-for="exp in event.location_experience" :key="exp"> &bull; {{exp}}</span></template></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p class="post-list" v-if="events.length === 0 && (filtersActive || search.length)">No results</p>
      <p class="post-list" v-else-if="eventsLoading">Loading...</p>
      <p class="post-list" v-else-if="events.length === 0 && !eventsLoading">No events have been scheduled. Check back soon!</p>

      <Components :components="pageData.acf.components" location="below" />
      <Footer />
    </div>

    <EventsFilters :events="events" :selectedEventType="selectedEventType" ref="filters" />
  </div>
</template>

<script>
import SubPageUtils from '../mixins/SubPageUtils';
import FiltersUtils from '../mixins/FiltersUtils';

import Components from '../components/Components';
import HeaderNav from '../components/HeaderNav';
import Footer from '../components/Footer';
import CellEvent from '../components/CellEvent';

import EventsFilters from "../components/EventsFilters";

export default {
  name: 'Events',
  components: { Components, HeaderNav, Footer, EventsFilters, CellEvent},
  mixins: [SubPageUtils, FiltersUtils],
  data() {
    return {
      pageData: {},
      eventsData: [],
      eventsLoading: true,
      selectedEventType: [],
    }
  },
  computed: {
    filterBySelectedEventType() {
      // Filter by filters
      if (this.selectedEventType.length) {
        let filter = this.eventsData.filter(event => {
          let hasFilter = false;
          this.selectedEventType.forEach((filter) => {
            if (event.event_type.toLowerCase() === filter.toLowerCase()) {
              hasFilter = true;
              return;
            };
          });

          return hasFilter;
        });

        return filter;
      } else {
        return this.eventsData;
      }
    },
    events() {
      // Filter by search
      let search = this.filterBySelectedEventType.filter(event => {
        let query = this.search.toLowerCase();
        let params;

        if (!query.length) return true;

        params = event.artist_name;
        params += ',' + event.program_title;
        params += ',' + moment(event.date).format('dddd, MMMM Do');
        params += ',' + moment(event.time, "H:mm").format("h:mm A");
        params += ',' + event.category;
        params += ',' + event.event_type;
        params += ',' + event.event_type_other;
        params += ',' + event.address;
        params += ',' + event.zip;
        params += ',' + event.location_type;
        params += ',' + event.location_experience.join(',');

        params = params.toLowerCase();

        return params.includes(query);
      });

      search.sort(function(a, b) {
        return new Date(`${a.date} ${a.time}`) - new Date(`${b.date} ${b.time}`);
      });

      return search;
    },
    days() {
      let events = this.events.filter(event => event.date);
      events = this.events.filter(event => new Date(`${event.date} ${event.time}`) > new Date());

      if (!events.length) events = this.events.filter(event => event.date);

      events = events.sort(function(a, b) {
        return new Date(`${a.date} ${a.time}`) - new Date(`${b.date} ${b.time}`);
      });

      events = events.map(event => {
        return {
          ...event,
          date: moment(event.date).format('dddd, MMMM Do'),
          time: moment(event.time, "H:mm").format("h:mm A"),
        }
      })

      return _.values(_.groupBy(events, 'date'));
    },
    filterNoticeDescription() {
      let filters = this.selectedEventType;

      let str = filters.slice(0, 2).join(', ');

      if (filters.length > 2) {
        str = filters.slice(0, 1).join(', ');
        str += ', ' + (filters.length - 1) + ' more';
      }

      return str || (this.search);
    },
    filtersActive() {
      return this.selectedEventType.length > 0;
    },
  },
  methods: {
    back() {
      this.$router.push('/');
    },
  },
  async mounted() {
    // Get page content
    const pageDataResponse = await fetch(`https://admin.austinstudiotour.org/wp-json/wp/v2/pages/19190`)
    this.pageData = await pageDataResponse.json();

    // Get events data
    const eventsResponse = await fetch(`${this.$root.api_url}getEvents?year=${this.$root.year}`);
    this.eventsData = await eventsResponse.json();
    this.eventsLoading = false;
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

.icon {
  background-image: url(../assets/img/icon-events.svg);
  background-size: 18px 21px;
}

@media (max-width: @mobile) {
  .page-search {
    box-shadow: none;
  }
}

.day {
  position: sticky;
  top: 100px;
  top: calc(~'100px + env(safe-area-inset-top)');
  padding: 10px 20px;
  z-index: 3;
  font-size: 22px;
  color: @themeColor3;
  background-color: #fff;
  border-top: 1px solid #e4e4e4;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  @media (min-width: @mobile) {
    position: relative;
    top: 0;
    margin: 50px 0 20px 0;
    padding: 0;
    border-top: 0;
    box-shadow: none;
    z-index: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Events.vue